import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../../_services/authentication.service";
import {data} from "jquery";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  environment = environment;

  constructor(
    private authsvc: AuthenticationService,
    private toastService: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  Reset() {
    if(this.email?.length >0)
      this.authsvc.recoverpwd(this.email).subscribe(data=> {
        this.toastService.info("Richiesta effettuata, attendi istruzioni via E_Mail")
        this.router.navigate(["/Login"]);
      })
    else
      this.toastService.info("Inserisci un email");
  }
}
